module.exports = __webpack_public_path__ + "img/个人主播.f4ab71e5.png";